import {createSlice, isAnyOf} from '@reduxjs/toolkit';
import {loadControlsForNode, updateBlinds, updateTemperature} from './actions';
import {ControlsState} from './types';

const initialState: ControlsState = {controlsByNode: {}};

const slice = createSlice({
  name: 'controls',
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadControlsForNode.pending, (state, action) => {
        const nodeId = action.meta.arg;
        const previousEntry = state.controlsByNode[nodeId];

        state.controlsByNode[nodeId] = {
          status: 'Loading',
          nodeId,
          lastLoadedTimestamp: new Date().toISOString(),
          controls: previousEntry?.controls ?? [],
        };
      })
      .addCase(loadControlsForNode.fulfilled, (state, action) => {
        const nodeId = action.meta.arg;

        state.controlsByNode[nodeId] = {
          ...state.controlsByNode[nodeId]!,
          status: 'Loaded',
          controls: action.payload,
        };
      })
      .addCase(loadControlsForNode.rejected, (state, action) => {
        const nodeId = action.meta.arg;

        state.controlsByNode[nodeId] = {
          ...state.controlsByNode[nodeId]!,
          status: 'Failed',
        };
      })

      .addMatcher(isAnyOf(updateBlinds.fulfilled, updateTemperature.fulfilled), (state, action) => {
        const {controlId, value} = action.meta.arg;

        // locally update all control's current value, when update was successful
        Object.values(state.controlsByNode)
          .flatMap((s) => s?.controls)
          .forEach((control) => {
            if (control?.id !== controlId) return;

            control.currentValue = value;
          });
      });
  },
});

export const {reducer: controlsReducer} = slice;
